module.exports = __webpack_public_path__ + "static/service_4-272a7dc7a790c647fad22dc0d496b20d.jpg";